import { z } from 'zod';
/**
 * Importador masivo de clientes desde CSV.
 *
 * Dos pasos a propósito: primero se PREVISUALIZA —se dice qué se ha entendido,
 * qué está repetido y qué está mal— y solo después se crea. Un importador de un
 * solo clic que mete 300 filas mal mapeadas obliga a limpiar a mano lo que ha
 * creado, y en una agenda de clientes eso es peor que no importar.
 */
export const ClientImportRowStatusSchema = z.enum([
    /** Se creará. */
    'nuevo',
    /** Ya existe alguien con ese correo o ese NIF: se salta. */
    'duplicado',
    /** Le falta algo imprescindible: se salta. */
    'error',
]);
export const ClientImportRowSchema = z.object({
    /** Número de fila del fichero (1 = primera fila de datos). */
    numero: z.number().int(),
    displayName: z.string(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    mobile: z.string().nullable(),
    nationalId: z.string().nullable(),
    city: z.string().nullable(),
    province: z.string().nullable(),
    web: z.string().nullable(),
    notes: z.string().nullable(),
    tags: z.array(z.string()),
    type: z.enum(['PERSONA', 'EMPRESA']),
    /** El tipo se dedujo del NIF porque el fichero no traía columna. */
    typeInferido: z.boolean(),
    status: ClientImportRowStatusSchema,
    /** Por qué está repetida o por qué falla, en un texto que se pueda leer. */
    motivo: z.string().nullable(),
    /** Con quién choca, si es duplicado. Para poder ir a mirarlo. */
    duplicadoDe: z.string().nullable(),
});
export const ClientImportPreviewResponseSchema = z.object({
    fileName: z.string(),
    separador: z.string(),
    columnasReconocidas: z.array(z.string()),
    /** Columnas del fichero que no se han entendido. Se ignoran, pero se dicen. */
    columnasIgnoradas: z.array(z.string()),
    filas: z.array(ClientImportRowSchema),
    resumen: z.object({
        total: z.number().int(),
        nuevos: z.number().int(),
        duplicados: z.number().int(),
        errores: z.number().int(),
        /** Etiquetas del fichero que NO existen todavía y se crearán al importar. */
        etiquetasNuevas: z.array(z.string()),
    }),
});
export const CommitClientImportSchema = z.object({
    fileName: z.string().min(1).max(255),
    /**
     * ☠️ OBLIGATORIA. De dónde sale la lista y por qué se puede usar. Se guarda
     * pegada a cada cliente que entra por el lote: es lo único que deja
     * constancia de la base jurídica antes de mandarle nada a esa gente.
     */
    origin: z
        .string()
        .trim()
        .min(10, 'Di de dónde sale la lista: es lo que justifica poder escribirles')
        .max(500),
    /** Solo las filas que se van a crear; las que el usuario haya descartado no vienen. */
    filas: z.array(ClientImportRowSchema).min(1).max(2000),
});
export const CommitClientImportResponseSchema = z.object({
    batchId: z.string(),
    creados: z.number().int(),
    /** Filas que llegaron marcadas para crear pero que ya existían al guardar. */
    saltados: z.number().int(),
    etiquetasCreadas: z.array(z.string()),
});
//# sourceMappingURL=client-import.js.map